import React, { useState, useContext, useEffect, useCallback } from 'react';
import upload from '../../../assets/img/ad/imageUpload.svg'
import LogoUploading from './LogoUploading';
import LogoUploadError from './LogoUploadError';
import LogoUploadSuccess from './LogoUploadSuccess';
import WizardDataContext from '../../../store/WizardDataContext';

import Dropzone from '../../ImageDropdown/Dropzone';


export default function LogoUpload({ setDisableBtn, companyId }) {


  const wizardCtx = useContext(WizardDataContext);
  const { wizardData, updateData } = wizardCtx;

  const [loading, setLoading] = useState(false)
  const [image, setImage] = useState()
  const [failed, setFailed] = useState(false)
  const [imageUploaded, setImageUploaded] = useState(false)
  const [isUploading, setIsUploading] = useState(false)

  // Check if there's already a logo in context when component mounts
  useEffect(() => {
    if (wizardData.logo.url) {
      setImageUploaded(true)
      setDisableBtn(false)
    }
  }, [wizardData.logo.url, setDisableBtn])

  useEffect(() => {
    if (image) {
      uploadLogoImg()
    } else {
      setDisableBtn(true)
    }
  }, [image])

  useEffect(() => {
    // Only enable the continue button when image is successfully uploaded
    if (imageUploaded && !isUploading) {
      setDisableBtn(false)
    } else {
      setDisableBtn(true)
    }
  }, [imageUploaded, isUploading])

  // get dropped images
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file && file.type.startsWith('image/')) {
      setImage(file);
    } else {
      alert('Please select an image file');
    }
  }, []);

  const uploadLogoImg = async () => {
    setIsUploading(true)
    setLoading(true)
    setFailed(false)

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("file", image);

      // Update company with logo file
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/advertising/${companyId}/uploadLogo`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        setImageUploaded(true)
        setLoading(false)
        // setDisableBtn(false)
        updateData('logo', { url: data.imagePath || data.logo })
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update company logo')
      }
    } catch (error) {
      console.error('Error uploading logo:', error)
      setFailed(true)
      setLoading(false)
      // setDisableBtn(true)
    } finally {
      setIsUploading(false)
    }
  }

  if (loading) {
    return <LogoUploading />
  }

  if (failed) {
    return <LogoUploadError setFailed={setFailed} setImage={setImage} setLoading={setLoading} onDrop={onDrop} />
  }

  if (imageUploaded) {
    return <LogoUploadSuccess image={image} setImage={setImage} setImageUploaded={setImageUploaded} />
  }

  return (
    <div className="step2-container">
      <div className="step2">
        <div className="step2-heading">
          <h2>Add Company Logo</h2>
        </div>
        <div className="step2-drop-image">
          <img src={upload} alt="upload" />
        </div>
        <div className="step2-drop-text">
          <p>Drag and drop your logo here, or <span className="browse" onClick={() => document.querySelector('.get-img').click()}>browse</span></p>
          <input 
            type="file" 
            className="get-img" 
            style={{ display: 'none' }}
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file && file.type.startsWith('image/')) {
                setImage(file);
              } else {
                alert('Please select an image file');
              }
            }} 
          />
        </div>
        <div className="d-n-d">
          <Dropzone 
            onDrop={onDrop} 
            accept={{
              'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp', '.svg']
            }}
          />
        </div>
      </div>
    </div>
  )
}
